import { render, staticRenderFns } from "./c-tab.vue?vue&type=template&id=73e6d8f8&"
import script from "./c-tab.vue?vue&type=script&lang=js&"
export * from "./c-tab.vue?vue&type=script&lang=js&"
import style0 from "./c-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports